import { render, staticRenderFns } from "./FilesandMedia.vue?vue&type=template&id=283666ec&scoped=true&"
import script from "./FilesandMedia.vue?vue&type=script&lang=js&"
export * from "./FilesandMedia.vue?vue&type=script&lang=js&"
import style0 from "./FilesandMedia.vue?vue&type=style&index=0&id=283666ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283666ec",
  null
  
)

export default component.exports